export { type CaseStudiesListProps, default as CaseStudiesList } from './CaseStudiesList';
